/* Custom Pet Shop – pillow builder v3 */
(function () {
  function init(root) {
    if (root.__cpb) return; root.__cpb = true;
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
    var cur = root.getAttribute('data-currency') || 'USD';
    var money = function (c) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100).replace(/\.00$/, ''); }
      catch (e) { return '$' + (c / 100).toFixed(2); }
    };
    var qs = new URLSearchParams(location.search);
    var petParam = (qs.get('pet') || '').toLowerCase();

    // --- headline variants for ad links (?pet=dog / ?pet=cat)
    if (petParam === 'dog' || petParam === 'cat') {
      $$('[data-pet-text]').forEach(function (el) { var v = el.getAttribute('data-' + petParam); if (v) el.textContent = v; });
      $$('[data-pet-html]').forEach(function (el) {
        var v = el.getAttribute('data-' + petParam); if (!v) return;
        var tmp = document.createElement('div'); tmp.innerHTML = v;
        tmp.querySelectorAll('*').forEach(function (n) { if (!/^(EM|STRONG|BR|B|I)$/.test(n.tagName)) n.replaceWith(document.createTextNode(n.textContent)); });
        el.innerHTML = tmp.innerHTML;
      });
    }

    // --- scrolling helpers
    $$('[data-cpb-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href')); if (!t) return;
        e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var sticky = $('[data-cpb-sticky]'), build = $('[data-cpb-buildsec]'), hero = $('.cpb-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var vis = { hero: true, build: false };
      var upd = function () { sticky.classList.toggle('show', !vis.hero && !vis.build); };
      new IntersectionObserver(function (es) { es.forEach(function (e) { vis.hero = e.isIntersecting; }); upd(); }, { threshold: 0.05 }).observe(hero);
      new IntersectionObserver(function (es) { es.forEach(function (e) { vis.build = e.isIntersecting; }); upd(); }, { threshold: 0.02 }).observe(build);
    }

    var form = $('[data-cpb-form]'); if (!form) return;
    var data = JSON.parse($('[data-cpb-product]').textContent);
    var products = data.products || [];
    var addons = data.addons || {};
    var product = products.filter(function (q) { return q.handle === data.current; })[0] || products[0];
    var variantInput = $('[data-cpb-variant]');
    var current = product.variants[0];

    var el = {
      name: $('[data-cpb-name]'), sizeStep: $('[data-cpb-size-step]'), sizeLabel: $('[data-cpb-size-label]'), sizeHint: $('[data-cpb-size-hint]'),
      price: $('[data-cpb-price]'), cmp: $('[data-cpb-compare]'), save: $('[data-cpb-save]'), stickyP: $('[data-cpb-sticky-price]'), submit: $('[data-cpb-submit]'),
      frame: $('[data-cpb-frame]'), photo: $('[data-cpb-photo]'), empty: $('[data-cpb-empty]'), exImg: $('.cpb-ex'), ptext: $('[data-cpb-ptext]'), thumbs: $('[data-cpb-thumbs]'),
      preview: $('[data-cpb-preview]'), love: $('[data-cpb-love]'), summary: $('[data-cpb-summary]'),
      textOn: $('[data-cpb-texton]'), textInputs: $('[data-cpb-textinputs]'), t1: $('[data-cpb-text1]'), t2: $('[data-cpb-text2]'), textField: $('[data-cpb-textfield]'), textLabel: $('[data-cpb-textlabel]'),
      sides: $('[data-cpb-sides]'), sidePrice: $('[data-cpb-sideprice]'), delText: $('[data-cpb-deltext]'), date: $('[data-cpb-date]'),
      fileErr: $('[data-cpb-file-err]'), err: $('[data-cpb-err]'), photoLabel: $('[data-cpb-photolabel]'), nameLabel: $('[data-cpb-namelabel]')
    };
    var state = { pet: 'Dog', count: 1, border: '#ffffff', borderName: 'White outline', bg: '', bgName: 'Original photo background', side: 'front', files: {} };

    // --- name personalisation
    var named = $$('[data-tpl]');
    named.forEach(function (n) { n.__def = n.textContent; });
    var petWord = function () { return state.pet === 'Dog' ? 'dog' : state.pet === 'Cat' ? 'cat' : 'pet'; };
    var applyName = function () {
      var n = (el.name.value || '').replace(/[<>"]/g, '').trim();
      named.forEach(function (node) {
        var tpl = node.getAttribute('data-tpl');
        node.textContent = n && tpl ? tpl.replace(/\[name\]/gi, n) : node.__def.replace(/\bpet('s)?\b/gi, function (m, s) { return petWord() + (s || ''); });
      });
      if (el.t1 && !el.t1.__touched) el.t1.value = n;
      renderText();
      try { sessionStorage.setItem('cpb-name', n); } catch (e) {}
    };

    // --- pet type & count
    var setPet = function (v) {
      state.pet = v;
      $$('[data-cpb-pet]').forEach(function (r) { r.checked = r.value === v; });
      el.name.placeholder = state.count > 1 ? 'e.g. Biscuit & Luna' : v === 'Cat' ? 'e.g. Luna' : v === 'Dog' ? 'e.g. Biscuit' : 'e.g. Coco';
      if (el.nameLabel) el.nameLabel.textContent = state.count > 1 ? 'Your pets\' names' : 'Your ' + petWord() + '\'s name';
      if (el.photoLabel) el.photoLabel.textContent = state.count > 1 ? 'Your pets\' photos' : 'Your ' + petWord() + '\'s photo';
      applyName();
    };
    $$('[data-cpb-pet]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setPet(r.value); }); });
    var petExtra = addons.pet ? addons.pet.price : 0;
    $$('[data-cpb-petprice]').forEach(function (s) { var n = +s.getAttribute('data-cpb-petprice'); s.textContent = petExtra ? '+' + money(petExtra * n) : ''; });
    $$('[data-cpb-count]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        state.count = +r.value;
        $$('[data-cpb-upload]').forEach(function (u) { u.hidden = +u.getAttribute('data-cpb-upload') > state.count; });
        setPet(state.pet); renderThumbs(); render();
      });
    });

    // --- sizes
    var label = function (val) {
      var lbl = val, sub = '';
      if (val.indexOf(':') > -1) {
        var parts = val.split(':');
        lbl = parts[1].split(' (')[0].trim();
        sub = (parts[0].split('(').pop() || '').replace(')', '');
        if (/most popular/i.test(val)) sub += ' · Most popular';
      } else if (/\(best seller\)/i.test(val)) {
        lbl = val.replace(/\(best seller\)/i, '').trim(); sub = 'Best seller';
      } else if (/^\d+x\d+$/.test(val)) {
        var d = val.split('x'); lbl = d[0] + '" × ' + d[1] + '"';
      }
      return { lbl: lbl, sub: sub };
    };
    var isPop = function (v) { return v.options.some(function (o) { return /most popular|best seller/i.test(o || ''); }); };
    var optNames = function () { return product.optionNames && product.optionNames.length ? product.optionNames : [product.option || 'Size']; };
    var match = function (sel) { return product.variants.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0]; };
    var hintText = el.sizeHint ? el.sizeHint.textContent : '';
    var buildSizes = function (keepIndex) {
      el.sizeStep.innerHTML = '';
      if (product.single) { el.sizeStep.hidden = true; current = product.variants[0]; return; }
      el.sizeStep.hidden = false;
      var pick = product.variants.filter(isPop)[0];
      if (keepIndex != null && product.variants[keepIndex]) pick = product.variants[keepIndex];
      pick = pick && pick.available ? pick : (product.variants.filter(function (v) { return v.available; })[0] || product.variants[0]);
      current = pick;
      optNames().forEach(function (name, k) {
        var values = [];
        product.variants.forEach(function (v) { if (values.indexOf(v.options[k]) < 0) values.push(v.options[k]); });
        var group = document.createElement('div'); group.className = 'cpb-optgroup';
        var lab = document.createElement('span'); lab.className = 'cpb-label'; lab.textContent = name;
        if (k === 0 && hintText && product.variants.some(isPop)) { var h = document.createElement('small'); h.textContent = hintText; lab.appendChild(document.createTextNode(' ')); lab.appendChild(h); }
        var chips = document.createElement('div'); chips.className = 'cpb-chips'; chips.setAttribute('role', 'radiogroup'); chips.setAttribute('aria-label', name);
        values.forEach(function (val) {
          var l = label(val);
          var wrap = document.createElement('label'); wrap.className = 'cpb-chip';
          var inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'cpb-o' + k + '-' + root.id; inp.value = val;
          inp.setAttribute('data-k', k); inp.checked = current.options[k] === val;
          var span = document.createElement('span');
          span.appendChild(document.createTextNode(l.lbl));
          if (l.sub) { var sm = document.createElement('small'); sm.textContent = l.sub; span.appendChild(sm); }
          var pr = document.createElement('small'); pr.setAttribute('data-cpb-optprice', ''); span.appendChild(pr);
          wrap.appendChild(inp); wrap.appendChild(span); chips.appendChild(wrap);
          inp.addEventListener('change', function () {
            var sel = current.options.slice(); sel[k] = val;
            var m = match(sel);
            if (!m || !m.available) m = product.variants.filter(function (v) { return v.options[k] === val && v.available; })[0] || m || current;
            current = m;
            $$('input[data-k]', el.sizeStep).forEach(function (i) { i.checked = current.options[+i.getAttribute('data-k')] === i.value; });
            render();
          });
        });
        group.appendChild(lab); group.appendChild(chips); el.sizeStep.appendChild(group);
      });
    };

    var applyKind = function () {
      el.frame.setAttribute('data-kind', product.kind === 'shaped' ? 'shaped' : product.kind === 'square' ? 'square' : 'other');
      var p2 = $('[data-cpb-p2]'); if (p2) p2.textContent = product.kind === 'other' ? 'Your design' : 'Your pillow';
      $$('[data-cpb-finish]').forEach(function (f) { f.hidden = f.getAttribute('data-cpb-finish') !== product.finish; });
      el.textField.hidden = product.text === 'none';
      if (product.text === 'on' && !el.textOn.__touched) { el.textOn.checked = true; }
      if (product.text === 'optional' && !el.textOn.__touched) { el.textOn.checked = false; }
      el.textLabel.textContent = product.text === 'on' ? 'Name & message on the pillow' : 'Add a name or message';
      el.t2.placeholder = product.text === 'on' ? 'e.g. Forever in my heart · 2012 – 2026' : 'Optional 2nd line, e.g. Best boy';
      el.textInputs.hidden = !el.textOn.checked;
      el.sides.hidden = product.sides !== 'yes';
      if (el.sides.hidden) { state.side = 'front'; var fr = $('[data-cpb-side="front"]'); if (fr) fr.checked = true; }
      renderText(); renderFrame();
    };
    var renderFrame = function () {
      el.frame.style.setProperty('--cpb-outline', product.finish === 'border' ? state.border : 'transparent');
      el.frame.style.setProperty('--cpb-bgc', product.finish === 'background' && state.bg ? state.bg : 'transparent');
      el.frame.classList.toggle('has-bg', product.finish === 'background' && !!state.bg);
      el.frame.classList.toggle('has-photo', !!state.files[1]);
    };
    var renderText = function () {
      var on = el.textOn && el.textOn.checked && !el.textField.hidden;
      var txt = on ? [el.t1.value.trim(), el.t2.value.trim()].filter(Boolean).join(' · ') : '';
      el.ptext.textContent = txt; el.ptext.hidden = !txt;
    };
    $$('[data-cpb-border]').forEach(function (r) { r.addEventListener('change', function () { state.border = r.getAttribute('data-cpb-border'); state.borderName = r.value; renderFrame(); render(); }); });
    $$('[data-cpb-bg]').forEach(function (r) { r.addEventListener('change', function () { state.bg = r.getAttribute('data-cpb-bg'); state.bgName = r.value; renderFrame(); render(); }); });
    el.textOn.addEventListener('change', function () { el.textOn.__touched = true; el.textInputs.hidden = !el.textOn.checked; renderText(); render(); if (el.textOn.checked) el.t1.focus(); });
    [el.t1, el.t2].forEach(function (i) { i.addEventListener('input', function () { i.__touched = true; renderText(); render(); }); });
    var sideExtra = addons.sides ? addons.sides.price : 0;
    if (el.sidePrice) el.sidePrice.textContent = sideExtra ? '+' + money(sideExtra) : '';
    $$('[data-cpb-side]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { state.side = r.getAttribute('data-cpb-side'); render(); } }); });

    // --- delivery date
    var addBiz = function (n) { var d = new Date(), a = 0; while (a < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) a++; } return d; };
    var renderDelivery = function () {
      var both = state.side === 'both' && !el.sides.hidden;
      if (el.delText) el.delText.textContent = el.delText.getAttribute(both ? 'data-both' : 'data-front') || el.delText.textContent;
      var days = +root.getAttribute(both ? 'data-days-both' : 'data-days') || 0;
      if (el.date) el.date.textContent = days ? '· Arrives by ' + addBiz(days).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : '';
    };

    // --- totals & summary
    var extras = function () {
      var list = [];
      if (state.count > 1 && addons.pet) list.push({ id: addons.pet.id, qty: state.count - 1, price: addons.pet.price });
      if (state.side === 'both' && !el.sides.hidden && addons.sides) list.push({ id: addons.sides.id, qty: 1, price: addons.sides.price });
      return list;
    };
    var render = function () {
      if (el.t1 && !el.t1.__touched) el.t1.value = (el.name.value || '').replace(/[<>"]/g, '').trim();
      variantInput.value = current.id;
      var total = current.price + extras().reduce(function (s, x) { return s + x.price * x.qty; }, 0);
      el.price.textContent = money(total);
      if (current.compare_at_price && current.compare_at_price > current.price) {
        el.cmp.textContent = money(current.compare_at_price + (total - current.price));
        el.save.hidden = false; el.save.textContent = 'Save ' + Math.round((1 - current.price / current.compare_at_price) * 100) + '%';
      } else { el.cmp.textContent = ''; el.save.hidden = true; }
      if (el.stickyP) el.stickyP.textContent = money(total);
      $$('input[data-k]', el.sizeStep).forEach(function (i) {
        var k = +i.getAttribute('data-k'), test = current.options.slice(); test[k] = i.value;
        var m = match(test);
        i.disabled = !m || !m.available;
        var sm = i.parentNode.querySelector('[data-cpb-optprice]');
        sm.textContent = m && m.price !== current.price ? (m.price > current.price ? '+' : '−') + money(Math.abs(m.price - current.price)) : '';
      });
      var bits = [];
      var styleCard = $('[data-cpb-style]:checked'); if (styleCard) bits.push(styleCard.closest('.cpb-style').querySelector('b').textContent);
      if (!product.single) current.options.forEach(function (o) { bits.push(label(o).lbl); });
      bits.push(state.count + ' ' + (state.count > 1 ? petWord() + 's' : petWord()));
      if (product.finish === 'border') bits.push(state.borderName);
      if (product.finish === 'background') bits.push(state.bgName.replace(' background', ' bg'));
      if (!el.sides.hidden) bits.push(state.side === 'both' ? 'Both sides' : 'Front only');
      if (el.textOn.checked && !el.textField.hidden && el.t1.value.trim()) bits.push('“' + el.t1.value.trim() + '”');
      el.summary.innerHTML = '';
      bits.forEach(function (b) { var s = document.createElement('span'); s.textContent = b; el.summary.appendChild(s); });
      el.submit.disabled = !current.available;
      if (!current.available) el.submit.textContent = 'Sold out'; else applyName();
      renderDelivery();
    };

    // --- style switching
    var setStyle = function (handle) {
      var q = products.filter(function (x) { return x.handle === handle; })[0]; if (!q) return;
      var idx = product.variants.indexOf(current);
      var same = q.variants.length === product.variants.length && q.variants.every(function (v, i) { return v.options[0] === product.variants[i].options[0]; });
      product = q;
      $$('[data-cpb-style]').forEach(function (r) { r.checked = r.value === handle; });
      buildSizes(same ? idx : null);
      if (el.exImg && q.image) { el.exImg.removeAttribute('srcset'); el.exImg.src = q.image; }
      applyKind(); render();
    };
    $$('[data-cpb-style]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setStyle(r.value); }); });

    // --- occasion → matching style
    $$('[data-cpb-occ]').forEach(function (r) {
      r.addEventListener('change', function () {
        var m = $$('.cpb-style').filter(function (l) { return l.getAttribute('data-occ') && l.getAttribute('data-occ') === r.value; })[0];
        if (m) setStyle(m.querySelector('input').value);
        if (r.value === 'In loving memory' && !el.textOn.__touched) { el.textOn.checked = true; el.textInputs.hidden = false; renderText(); render(); }
      });
    });
    $$('[data-cpb-pick-occ]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-cpb-pick-occ');
        $$('[data-cpb-occ]').forEach(function (r) { if (r.value === v) { r.checked = true; r.dispatchEvent(new Event('change')); } });
        build.scrollIntoView({ behavior: 'smooth' });
      });
    });

    // --- gallery (product layout)
    $$('[data-cpb-gallery] button').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-cpb-gallery] button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (el.exImg) { el.exImg.removeAttribute('srcset'); el.exImg.src = b.getAttribute('data-src'); }
        if (state.files[1]) { el.photo.hidden = true; el.empty.hidden = false; }
      });
    });

    // --- photo uploads
    var MAX = 20 * 1024 * 1024;
    var showErr = function (n, msg) { n.textContent = msg || ''; n.classList.toggle('show', !!msg); };
    var renderThumbs = function () {
      el.thumbs.innerHTML = '';
      var keys = Object.keys(state.files).filter(function (k) { return +k <= state.count; });
      el.thumbs.hidden = keys.length < 2;
      keys.forEach(function (k) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'cpb-thumb';
        var i = document.createElement('img'); i.src = state.files[k]; i.alt = 'Pet ' + k; b.appendChild(i);
        b.addEventListener('click', function () { el.photo.src = state.files[k]; el.photo.hidden = false; el.empty.hidden = true; });
        el.thumbs.appendChild(b);
      });
    };
    $$('[data-cpb-upload]').forEach(function (box) {
      var n = +box.getAttribute('data-cpb-upload');
      var input = $('[data-cpb-file]', box), drop = $('[data-cpb-drop]', box), title = $('[data-cpb-drop-title]', box), sub = $('[data-cpb-drop-sub]', box);
      var onFile = function () {
        var f = input.files && input.files[0];
        showErr(el.fileErr, '');
        if (!f) return;
        if (f.size > MAX) { input.value = ''; showErr(el.fileErr, 'That photo is over 20 MB. Please choose a smaller one.'); return; }
        if (f.type && !/^image\//.test(f.type) && !/\.(heic|heif)$/i.test(f.name)) { input.value = ''; showErr(el.fileErr, 'Please choose a photo file.'); return; }
        title.textContent = (n > 1 ? 'Pet ' + n + ' photo added' : 'Photo added') + ' ✓';
        sub.textContent = (f.name.length > 30 ? f.name.slice(0, 27) + '…' : f.name) + ' · tap to change';
        box.classList.add('is-done');
        var url = URL.createObjectURL(f);
        state.files[n] = url;
        if (n === 1 || el.photo.hidden) {
          el.photo.onload = function () { el.photo.hidden = false; el.empty.hidden = true; };
          el.photo.onerror = function () { el.photo.hidden = true; el.empty.hidden = false; };
          el.photo.src = url;
        }
        el.preview.classList.add('has-photo');
        renderThumbs(); renderFrame();
      };
      input.addEventListener('change', onFile);
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
          try { var dt = new DataTransfer(); dt.items.add(e.dataTransfer.files[0]); input.files = dt.files; } catch (er) {}
          onFile();
        }
      });
    });

    // --- add to cart
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    form.addEventListener('submit', function (e) {
      e.preventDefault(); showErr(el.err, '');
      var missing = $$('[data-cpb-upload]').filter(function (u) { return !u.hidden && !$('[data-cpb-file]', u).files.length; });
      if (missing.length) {
        showErr(el.fileErr, state.count > 1 ? 'Please add a photo for each pet so our designer can start.' : 'Please add a photo of your ' + petWord() + ' so our designer can start.');
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
      }
      var fd = new FormData(form);
      fd.set('id', current.id); fd.set('quantity', '1');
      ['Pet name', 'Notes for designer'].forEach(function (k) { var v = fd.get('properties[' + k + ']'); if (!v || !String(v).trim()) fd.delete('properties[' + k + ']'); });
      $$('[data-cpb-upload]').forEach(function (u) { if (u.hidden) { var i = $('[data-cpb-file]', u); fd.delete(i.name); } });
      fd.set('properties[Number of pets]', String(state.count));
      if (product.finish === 'border') fd.set('properties[Outline]', state.borderName);
      if (product.finish === 'background') fd.set('properties[Background]', state.bgName);
      if (!el.textField.hidden && el.textOn.checked && (el.t1.value.trim() || el.t2.value.trim())) {
        fd.set('properties[Text on pillow]', [el.t1.value.trim(), el.t2.value.trim()].filter(Boolean).join(' / '));
      }
      if (!el.sides.hidden) fd.set('properties[Print]', state.side === 'both' ? 'Both sides' : 'Front only');
      var key = 'cpb' + Date.now().toString(36);
      fd.set('properties[_build]', key);
      var label0 = el.submit.textContent;
      el.submit.disabled = true; el.submit.textContent = 'Adding to cart…';
      fetch(root_url + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); return j; }); })
        .then(function () {
          var ex = extras();
          if (!ex.length) return;
          return fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: ex.map(function (x) { return { id: x.id, quantity: x.qty, properties: { _build: key, For: (el.name.value || 'your pillow').trim() } }; }) }) });
        })
        .then(function () { window.location.href = root_url + 'cart'; })
        .catch(function (ex) { el.submit.disabled = false; el.submit.textContent = label0; showErr(el.err, ex.message + ' Please try again.'); });
    });

    // --- start
    try { var saved = sessionStorage.getItem('cpb-name'); if (saved) el.name.value = saved; } catch (e) {}
    el.name.addEventListener('input', render);
    if (!$('[data-cpb-style]:checked') && $('[data-cpb-style]')) { $('[data-cpb-style]').checked = true; product = products[0]; }
    var styleParam = (qs.get('style') || '').toLowerCase();
    if (styleParam) {
      var hit = products.filter(function (q) { return q.handle === styleParam || (q.alias && q.alias.toLowerCase() === styleParam); })[0];
      if (hit) product = hit;
      $$('[data-cpb-style]').forEach(function (r) { r.checked = r.value === product.handle; });
    }
    buildSizes(null);
    applyKind();
    setPet(petParam === 'cat' ? 'Cat' : petParam === 'other' ? 'Other pet' : 'Dog');
    if (petParam === 'other') { $$('[data-cpb-pet]').forEach(function (r) { r.checked = r.value === 'Other pet'; }); }
    render();
  }
  var go = function () { document.querySelectorAll('[data-cpb]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  document.addEventListener('shopify:section:load', go);
})();
